export default __webpack_public_path__ + "static/media/Clan Bound Girdle of the Greensward.580e55ee.jpg";